<template>
  <v-layout row wrap align-content-start fill-height class="pa-4 admin-page">
    <v-flex xs12 class="page-head-container mb-3">
      <v-flex xs12 class="mb-4 page-head-container">
        <h1 class="headline font-weight-light">{{ $t('wash_Instrument.list') }}</h1>
      </v-flex>

      <v-flex xs12 class="search-container">
        <v-text-field
          :label="$t('common.search')"
          solo
          flat
          hide-details
          v-model="search"
        ></v-text-field>
      </v-flex>

      <v-flex xs12>
        <template>
          <v-data-table
            v-if="getWashInstruments.length > 0"
            :headers="headers"
            :items="getWashInstruments"
            :pagination.sync="pagination"
            :search="search"
            hide-actions
            class="my-4"
            :disable-initial-sort=true >


            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  id="washInstrument"
                  v-for="header in headers"
                  :key="header.text"
                  :class="['column sortable', pagination.order ? 'desc' : 'asc', header.value === pagination.title ? 'active' : '']"
                  @click="changeSort(header.value)"
                >
                  <v-icon small>arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="props">
              <tr @click="clickItem(props.item)">
                <td>
                  <v-edit-dialog
                    :return-value.sync="props.item.wash_instrument"
                    lazy
                    @save="updateWashInstrument(props.item.id, 'wash_instrument', tempItem.wash_instrument)"
                  > {{ props.item.wash_instrument }}
                    <v-text-field
                      slot="input"
                      v-model="tempItem.wash_instrument"
                      label="Edit"
                      single-line
                    ></v-text-field>
                  </v-edit-dialog>
                </td>
              </tr>
            </template>
          </v-data-table>
        </template>
      </v-flex>
    </v-flex>

    <v-btn icon fixed bottom right fab color="primary" @click="addWashInstrument">
      <v-icon>add</v-icon>
    </v-btn>

    <v-snackbar
      v-model="snackbar"
      bottom
      :timeout="timeout"
      color="green"
    >
      {{ $t('wash_Instrument.added') }}
    </v-snackbar>
  </v-layout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  export default {
    name: 'AdminWashInstrumentList',
    data() {
      return {
        search: '',
        pagination: {
          rowsPerPage: -1,
          title:'',
          order:false
        },
        headers: [
          {
            text: this.$t('wash_Instrument.title'),
            align: 'left',
            value: 'wash_instrument',
            // sortable: false
          }
        ],
        snackbar: false,
        timeout: 3000,
        tempItem:'',
        tempValue:''
      }
    },

    computed: {
      ...mapGetters('washInstruments', [
        'getWashInstruments'
      ])
    },

    created () {
      this.fetchWashInstruments()
    },

    methods: {
      ...mapActions('washInstruments', [
        'fetchWashInstruments'
      ]),
      changeSort (column) {
        if(column===''){return;}
        if (this.pagination.title === column) {
          this.pagination.order = !this.pagination.order
        } else {
          this.pagination.title = column
          this.pagination.order = false
        }
        this.$store.dispatch('washInstruments/sortWashInstrument', {title:column,order:this.pagination.order})

      },

      updateWashInstrument ( washInstrumentID, field, value ) {
        // console.log(washInstrumentID,field,value)
        const updateObj = {
          washInstrumentID: washInstrumentID,
          field: field,
          value: value
        }
        
        this.$store.dispatch('washInstruments/updateColumnById', updateObj)
      },

      async addWashInstrument () {
        try {
          await this.$store.dispatch('washInstruments/addWashInstrument')
          this.snackbar = true
        } catch (e) {
          this.snackbar = false
        }
      },
      clickItem(data){
        this.tempItem = Object.assign({}, data);
      }
    }
  }
</script>

<style lang="scss">
</style>